import api from '@edu-fe/api'
import Cookie from 'js-cookie'

export default {
  name: 'live',
  getData: api.create('/live/pull/url'),
  getFreeData: api.create('/free/live/pull/url'),
  imageToBase64: api.create('/image/base64'),
  reportBehavior: api.create('/live/statistic'),
  getOrderQrcode: api.create('/weixin/live/sub/qrcode'),
  appoint: api.create('/live/appointment'),
  getUserInfo: api.create(`/user_info?userId=${Cookie.get('openid')}`),
  getRecommendCourse: api.create('/live/pull/recommend'),
  recordCourseProcess: api.create('/course/record', { method: 'POST', formData: true }),
}
